/* tslint:disable */
/* eslint-disable */
/**
 * Admin API
 * Internal Admin API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  CreateOrganization400Response,
  GetPayoutReport200Response,
  GetTransactionsReport200ResponseInner,
  GetTransactionsStats200Response,
} from '../models/index';
import {
    CreateOrganization400ResponseFromJSON,
    CreateOrganization400ResponseToJSON,
    GetPayoutReport200ResponseFromJSON,
    GetPayoutReport200ResponseToJSON,
    GetTransactionsReport200ResponseInnerFromJSON,
    GetTransactionsReport200ResponseInnerToJSON,
    GetTransactionsStats200ResponseFromJSON,
    GetTransactionsStats200ResponseToJSON,
} from '../models/index';

export interface GetLegalEntityKYCStatusRequest {
    legalEntityId: string;
}

export interface GetPayoutReportRequest {
    payoutId: string;
}

export interface GetTransactionsReportRequest {
    search?: string;
    startDate?: string;
    endDate?: string;
    minAmount?: number;
    maxAmount?: number;
    searchQuery?: string;
    offset?: number;
    limit?: number;
    payoutId?: string;
}

export interface GetTransactionsStatsRequest {
    search?: string;
    startDate?: string;
    endDate?: string;
    minAmount?: number;
    maxAmount?: number;
    searchQuery?: string;
    offset?: number;
    limit?: number;
    payoutId?: string;
}

/**
 * 
 */
export class PaymentsReportsApi extends runtime.BaseAPI {

    /**
     */
    async getLegalEntityKYCStatusRaw(requestParameters: GetLegalEntityKYCStatusRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<string>> {
        if (requestParameters['legalEntityId'] == null) {
            throw new runtime.RequiredError(
                'legalEntityId',
                'Required parameter "legalEntityId" was null or undefined when calling getLegalEntityKYCStatus().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/payments/legal-entities/{legalEntityId}/kyc-status`.replace(`{${"legalEntityId"}}`, encodeURIComponent(String(requestParameters['legalEntityId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<string>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     */
    async getLegalEntityKYCStatus(requestParameters: GetLegalEntityKYCStatusRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<string> {
        const response = await this.getLegalEntityKYCStatusRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getPayoutReportRaw(requestParameters: GetPayoutReportRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetPayoutReport200Response>> {
        if (requestParameters['payoutId'] == null) {
            throw new runtime.RequiredError(
                'payoutId',
                'Required parameter "payoutId" was null or undefined when calling getPayoutReport().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/payments/reports/payouts/{payoutId}/`.replace(`{${"payoutId"}}`, encodeURIComponent(String(requestParameters['payoutId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetPayoutReport200ResponseFromJSON(jsonValue));
    }

    /**
     */
    async getPayoutReport(requestParameters: GetPayoutReportRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetPayoutReport200Response> {
        const response = await this.getPayoutReportRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getTransactionsReportRaw(requestParameters: GetTransactionsReportRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<GetTransactionsReport200ResponseInner>>> {
        const queryParameters: any = {};

        if (requestParameters['search'] != null) {
            queryParameters['search'] = requestParameters['search'];
        }

        if (requestParameters['startDate'] != null) {
            queryParameters['startDate'] = requestParameters['startDate'];
        }

        if (requestParameters['endDate'] != null) {
            queryParameters['endDate'] = requestParameters['endDate'];
        }

        if (requestParameters['minAmount'] != null) {
            queryParameters['minAmount'] = requestParameters['minAmount'];
        }

        if (requestParameters['maxAmount'] != null) {
            queryParameters['maxAmount'] = requestParameters['maxAmount'];
        }

        if (requestParameters['searchQuery'] != null) {
            queryParameters['searchQuery'] = requestParameters['searchQuery'];
        }

        if (requestParameters['offset'] != null) {
            queryParameters['offset'] = requestParameters['offset'];
        }

        if (requestParameters['limit'] != null) {
            queryParameters['limit'] = requestParameters['limit'];
        }

        if (requestParameters['payoutId'] != null) {
            queryParameters['payoutId'] = requestParameters['payoutId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/payments/reports/transactions`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(GetTransactionsReport200ResponseInnerFromJSON));
    }

    /**
     */
    async getTransactionsReport(requestParameters: GetTransactionsReportRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<GetTransactionsReport200ResponseInner>> {
        const response = await this.getTransactionsReportRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getTransactionsStatsRaw(requestParameters: GetTransactionsStatsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetTransactionsStats200Response>> {
        const queryParameters: any = {};

        if (requestParameters['search'] != null) {
            queryParameters['search'] = requestParameters['search'];
        }

        if (requestParameters['startDate'] != null) {
            queryParameters['startDate'] = requestParameters['startDate'];
        }

        if (requestParameters['endDate'] != null) {
            queryParameters['endDate'] = requestParameters['endDate'];
        }

        if (requestParameters['minAmount'] != null) {
            queryParameters['minAmount'] = requestParameters['minAmount'];
        }

        if (requestParameters['maxAmount'] != null) {
            queryParameters['maxAmount'] = requestParameters['maxAmount'];
        }

        if (requestParameters['searchQuery'] != null) {
            queryParameters['searchQuery'] = requestParameters['searchQuery'];
        }

        if (requestParameters['offset'] != null) {
            queryParameters['offset'] = requestParameters['offset'];
        }

        if (requestParameters['limit'] != null) {
            queryParameters['limit'] = requestParameters['limit'];
        }

        if (requestParameters['payoutId'] != null) {
            queryParameters['payoutId'] = requestParameters['payoutId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/payments/reports/transactions/stats`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetTransactionsStats200ResponseFromJSON(jsonValue));
    }

    /**
     */
    async getTransactionsStats(requestParameters: GetTransactionsStatsRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetTransactionsStats200Response> {
        const response = await this.getTransactionsStatsRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
